module.exports = __webpack_public_path__ + "static/img/PU_H5.66b72cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/PU_H5.png
// module id = VCi+
// module chunks = 34